import { render, staticRenderFns } from "./PidTransactionsTable.vue?vue&type=template&id=117cf145&scoped=true&"
import script from "./PidTransactionsTable.vue?vue&type=script&lang=js&"
export * from "./PidTransactionsTable.vue?vue&type=script&lang=js&"
import style0 from "./PidTransactionsTable.vue?vue&type=style&index=0&id=117cf145&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117cf145",
  null
  
)

export default component.exports